var map = {
	"./de/chronicleImgActive.png": "4Fmz",
	"./en/chronicleImgActive.png": "44Cz",
	"./es/chronicleImgActive.png": "ffHs",
	"./fr/chronicleImgActive.png": "8SQI",
	"./ja/chronicleImgActive.png": "6SoR",
	"./ko/chronicleImgActive.png": "FajC",
	"./pt/chronicleImgActive.png": "zkZY",
	"./ru/chronicleImgActive.png": "XBjJ",
	"./tc/chronicleImgActive.png": "lVv5",
	"./th/chronicleImgActive.png": "arho"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "inxa";